import { render, staticRenderFns } from "./PlayerProfile.vue?vue&type=template&id=5914faeb"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1DesktopProfilesMyProfile: require('/app/components/Theme1/Desktop/Profiles/MyProfile.vue').default,Theme1ProfileLayout: require('/app/components/Theme1/ProfileLayout.vue').default})
